exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning-to-fill-others {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.warning-to-fill-others span {\r\n  font-size: 12px;\r\n  color: #464646;\r\n  position: relative;\r\n  z-index: 2;\r\n  line-height: 12px;\r\n}\r\n\r\n.warning-to-fill-others .fa {\r\n  color: #f0ad4e;\r\n  font-weight: bold;\r\n  font-size: 23px;\r\n  position: absolute;\r\n  z-index: 0;\r\n  top: 1px;\r\n  opacity: 0.6;\r\n  right: 0px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/my-questionnaires/my-questionnaires.component.css
// module id = ../../../../../src/app/components/my-questionnaires/my-questionnaires.component.css
// module chunks = 0